import { useEffect, useState } from 'react'
import { ButtonSecundario, ButtonClose } from '../../ui'
import { EditarPerfilLogoProps } from '@/types'
import { buildImageUrl } from '@/api/buildImageUrl';

const EditarPerfilLogoForm: React.FC<EditarPerfilLogoProps> = ({
  logoName,
  logoPreview,
  onAdd,
  onRemove,
  perfil_profesional_id,
  /*   token, */
}) => {
  const [pendingFile, setPendingFile] = useState<File | null>(null)
  const [pendingURL, setPendingURL] = useState<string | undefined>(undefined)
  const [imageError, setImageError] = useState(false)

  useEffect(() => {
    setImageError(false)
  }, [logoPreview, pendingURL, logoName])

  useEffect(() => {
    if (!pendingFile) {
      setPendingURL(undefined)
      return
    }
    const url = URL.createObjectURL(pendingFile)
    setPendingURL(url)
    return () => URL.revokeObjectURL(url)
  }, [pendingFile])

  const handleAddClick = () =>
    document.getElementById(`upload-logo-${perfil_profesional_id}`)?.click()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file || !file.type.startsWith('image/')) return

    const previewURL = URL.createObjectURL(file)
    setPendingFile(file)
    setPendingURL(previewURL)

    // 🔹 Aquí se llama al callback del padre para que suba la imagen si quiere
    onAdd?.(previewURL, file)

    e.target.value = ''
  }
  const handleRemoveClick = () => {
    setPendingFile(null)
    setPendingURL(undefined)
    onRemove?.(logoName)   // ✅ enviamos el nombre del archivo
  }

  const buildSrc = (): string | undefined => {
    if (pendingURL) return pendingURL
    if (logoPreview) return logoPreview
    if (!logoName) return undefined
    return buildImageUrl(logoName)
  }

  const srcToDisplay = buildSrc()

  return (
    <div className="logoPerfil">
      <div className="flex flex-col items-center space-y-2">
        <ButtonSecundario onClick={handleAddClick}>
          {srcToDisplay ? 'Cambiar Logo' : 'Subir Logo'}
        </ButtonSecundario>
        <input
          id={`upload-logo-${perfil_profesional_id}`}
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="hidden"
        />
      </div>

      {srcToDisplay && (
        <div className="mt-2 flex justify-center">
          <div className="relative w-24 h-12 rounded-lg overflow-hidden border bg-black">

            {/* Fondo blur */}
            <div
              className="absolute inset-0 bg-cover bg-center blur-lg opacity-80 scale-110"
              style={{ backgroundImage: `url(${srcToDisplay})` }}
            />

            {/* Imagen principal */}
            <img
              src={imageError ? '/img/logo/LogoLinkServs.png' : srcToDisplay}
              alt="Logo del profesional"
              className="relative z-10 w-full h-full object-contain"
              onError={() => setImageError(true)}
            />

            <ButtonClose
              onClick={handleRemoveClick}
              className="absolute top-1 right-1 rounded-sm z-20"
            />
          </div>
        </div>
      )}


    </div>
  )
}

export default EditarPerfilLogoForm
